import { GeneralCompanySettings } from '@wilson/interfaces';

export class FetchGeneralCompanySettingsIfNeeded {
  static readonly type =
    '[GeneralCompanySettings] Fetch General Company Settings If Needed';
}

export class UpdateGeneralGeneralCompanySettings {
  static readonly type =
    '[GeneralCompanySettings] Update General Company Settings';
  constructor(public generalCompanySettings: GeneralCompanySettings) {}
}

export class CreateGeneralGeneralCompanySettings {
  static readonly type =
    '[GeneralCompanySettings] Create General Company Settings';
  constructor(public generalCompanySettings: GeneralCompanySettings) {}
}

export class PatchGeneralCompanySettingsManagerApprovalState {
  static readonly type =
    '[GeneralCompanySettings] Update Manager Approval State Settings';
  constructor(public isManagerApprovalRequired: boolean) {}
}

export class PatchGeneralCompanySettingsMasterDeciderApprovalState {
  static readonly type =
    '[GeneralCompanySettings] Update Master Decider Approval State Settings';
  constructor(public isMasterDeciderApprovalRequired: boolean) {}
}

export class PatchGeneralCompanySettingsLeaveCarryoverState {
  static readonly type =
    '[GeneralCompanySettings] Update Leave Carryover State Settings';
  constructor(public isLeaveCarryoverEnabled: boolean) {}
}

export class ForceFetchGeneralCompanySettings {
  static readonly type =
    '[GeneralCompanySettings] Force Fetch General Company Settings';
}
